(() => {
  const urls = Array.isArray(window.homepageDeferredStyles)
    ? window.homepageDeferredStyles.filter(Boolean)
    : [];
  if (!urls.length) return;

  let loaded = false;
  const load = () => {
    if (loaded) return;
    loaded = true;
    urls.forEach(href => {
      if (Array.from(document.styleSheets).some(sheet => sheet.href === href)) return;
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      document.head.appendChild(link);
    });
  };

  const target = document.querySelector('[data-featured-product-scroll], .products-grid');
  if (!target || !('IntersectionObserver' in window)) {
    load();
    return;
  }

  const observer = new IntersectionObserver(entries => {
    if (!entries.some(entry => entry.isIntersecting)) return;
    observer.disconnect();
    load();
  }, { rootMargin: '700px 0px', threshold: 0.01 });
  observer.observe(target);

  document.querySelector('.mini-cart')?.addEventListener('pointerenter', load, { once: true });
  document.querySelector('.mini-cart')?.addEventListener('focusin', load, { once: true });
})();
